function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("liXBd", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "Header", ()=>$d49777bd9f9a71cc$export$8b251419efc915eb);
    $parcel$export(module.exports, "MainContent", ()=>$d49777bd9f9a71cc$export$5c0547b091a4b556);
    $parcel$export(module.exports, "ArchiveModalButtons", ()=>$d49777bd9f9a71cc$export$ff32e391fb6121b3);
    $parcel$export(module.exports, "default", ()=>$d49777bd9f9a71cc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $eCeGD;
    var $l1N8i;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $i8Qvm;
    var $cgL5K;
    var $7CMCs;
    var $6s1PB;
    var $pa9q9;
    var $aWse0;
    var $jXF09;
    var $3fAi8;
    var $iXVV6;
    var $8zOmE;
    var $isuse;
    var $5ING5;
    var $cDZaH;
    var $c441l;
    var $b9xX7;
    var $5l8yo;
    var $25qsa;
    const $d49777bd9f9a71cc$export$8b251419efc915eb = ({ title: title })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "medium"
        }, title);
    const $d49777bd9f9a71cc$export$5c0547b091a4b556 = ({ message: message })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, message);
    const $d49777bd9f9a71cc$export$ff32e391fb6121b3 = ({ text: text })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            weight: "medium",
            color: "inherit"
        }, text);
    const $d49777bd9f9a71cc$var$ArchiveIssueModal = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { isArchiveIssueModalOpen: isArchiveIssueModalOpen, issueKey: issueKey, issueId: issueId, onCloseIssueViewModal: onCloseIssueViewModal, onIssueArchiveSuccess: onIssueArchiveSuccess, triggerPointKey: triggerPointKey } = (0, (0, parcelRequire("c441l")).useArchiveIssueModalStates)();
        const { closeArchiveIssueModal: closeArchiveIssueModal } = (0, (0, parcelRequire("cDZaH")).useArchiveIssueModalActions)();
        const archiveIssue = (0, (0, parcelRequire("5l8yo")).useArchiveIssue)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const issueKeyString = issueKey || '';
        const [issuetype] = (0, (0, parcelRequire("3fAi8")).useFieldValue)({
            issueKey: issueKeyString,
            fieldKey: 'issuetype'
        });
        const hierarchyLevel = issuetype?.hierarchyLevel || 0;
        const archiveIssueUrl = (0, (0, parcelRequire("jXF09")).useArchiveIssueUrl)();
        const onError = ()=>{
            showFlag({
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("b9xX7")).default).issueArchivalErrorFlagTitleIssueTermRefresh : (0, (0, parcelRequire("b9xX7")).default).issueArchivalErrorFlagTitle, {
                    issueKey: issueKey
                }),
                testId: 'jira-issue-archive.modal.error-flag'
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({
                action: 'archived',
                actionSubject: 'issue',
                attributes: {
                    triggerPointKey: triggerPointKey
                }
            }), 'archiveIssue Failed');
            closeArchiveIssueModal();
        };
        const onSuccess = ()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({
                action: 'archived',
                actionSubject: 'issue',
                attributes: {
                    triggerPointKey: triggerPointKey
                }
            }), 'archiveIssue Successful');
            if ((0, (0, parcelRequire("25qsa")).isIssueViewPage)()) {
                window.location.reload();
                return;
            }
            if (issueKey && issueId) onIssueArchiveSuccess?.({
                issueKey: issueKey,
                issueId: issueId
            });
            showFlag({
                type: 'success',
                title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("b9xX7")).default).issueArchivalSuccessFlagTitleIssueTermRefresh : (0, (0, parcelRequire("b9xX7")).default).issueArchivalSuccessFlagTitle, {
                    issueKey: issueKey
                }),
                testId: 'jira-issue-archive.modal.success-flag',
                actions: [
                    {
                        content: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("b9xX7")).default).issueArchivalSuccessFlagActionViewIssueIssueTermRefresh : (0, (0, parcelRequire("b9xX7")).default).issueArchivalSuccessFlagActionViewIssue,
                        href: `/browse/${issueKey}`
                    },
                    {
                        content: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("b9xX7")).default).issueArchivalSuccessFlagActionViewInArchiveIssueTermRefresh : (0, (0, parcelRequire("b9xX7")).default).issueArchivalSuccessFlagActionViewInArchive,
                        href: archiveIssueUrl
                    }
                ]
            });
        };
        const onCloseHandler = (analyticsEvent)=>{
            closeArchiveIssueModal();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'goBackArchiveIssueModalClick');
        };
        const onArchiveHandler = (analyticsEvent)=>{
            archiveIssue(issueKey, onSuccess, onError);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'archiveArchiveIssueModalClick');
            onCloseIssueViewModal?.();
            closeArchiveIssueModal();
        };
        (0, $5uXOq.useEffect)(()=>{
            const preventKeyPropagationKeyDownHandler = (event)=>{
                if (isArchiveIssueModalOpen && event instanceof KeyboardEvent) {
                    if (event.key === (0, (0, parcelRequire("5ING5")).ESC_KEY)) {
                        event.preventDefault();
                        closeArchiveIssueModal();
                    }
                    event.stopPropagation();
                }
            };
            document.addEventListener('keydown', preventKeyPropagationKeyDownHandler, true);
            return ()=>{
                document.removeEventListener('keydown', preventKeyPropagationKeyDownHandler, true);
            };
        }, [
            closeArchiveIssueModal,
            isArchiveIssueModalOpen
        ]);
        let archiveIssueModalDescription;
        if (hierarchyLevel === 0) archiveIssueModalDescription = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("b9xX7")).default).archiveModalDescriptionIssueTermRefresh : (0, (0, parcelRequire("b9xX7")).default).archiveModalDescription;
        else archiveIssueModalDescription = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("b9xX7")).default).archiveModalDescriptionLOneIssueTermRefresh : (0, (0, parcelRequire("b9xX7")).default).archiveModalDescriptionLOne;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "jiraArchiveIssueModal",
            packageName: "jiraIssueArchivalModal",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isArchiveIssueModalOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            sourceName: "archiveIssue",
            attributes: {
                triggerPointKey: triggerPointKey
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: closeArchiveIssueModal,
            width: (0, (0, parcelRequire("5ING5")).ARCHIVE_ISSUE_MODAL_WIDTH_CATEGORY),
            testId: "issue-archival-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: (analyticsEvent)=>(0, (0, parcelRequire("8zOmE")).fireScreenAnalytics)(analyticsEvent)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            appearance: "warning"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d49777bd9f9a71cc$export$8b251419efc915eb, {
            title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("b9xX7")).default).archiveModalTitleIssueTermRefresh : (0, (0, parcelRequire("b9xX7")).default).archiveModalTitle)
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($d49777bd9f9a71cc$export$5c0547b091a4b556, {
            message: formatMessage(archiveIssueModalDescription, {
                b: (chunk)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                        as: "strong"
                    }, chunk),
                br: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("br", null)
            })
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "subtle",
            onClick: (event, analyticsEvent)=>{
                onCloseHandler(analyticsEvent);
            },
            testId: "issue-archival-modal.go-back-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d49777bd9f9a71cc$export$ff32e391fb6121b3, {
            text: formatMessage((0, (0, parcelRequire("b9xX7")).default).closeArchiveModalButton)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "warning",
            onClick: (event, analyticsEvent)=>{
                onArchiveHandler(analyticsEvent);
            },
            testId: "issue-archival-modal.restore-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d49777bd9f9a71cc$export$ff32e391fb6121b3, {
            text: formatMessage((0, (0, parcelRequire("b9xX7")).default).issueArchiveButton)
        })))))));
    };
    var $d49777bd9f9a71cc$export$2e2bcd8739ae039 = $d49777bd9f9a71cc$var$ArchiveIssueModal;
});
parcelRegister("jXF09", function(module, exports) {
    $parcel$export(module.exports, "useArchiveIssueUrl", ()=>$7c39c382a0d0ffa7$export$d1ca368e1ad6dfeb);
    var $2vSU6;
    var $dAfqg;
    const $7c39c382a0d0ffa7$export$d1ca368e1ad6dfeb = ()=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { projectType: projectType, simplified: simplified, projectKey: projectKey } = projectContext || {};
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if (simplified) return `/jira/software/projects/${projectKey}/issues/archive`;
                return `/jira/software/c/projects/${projectKey}/issues/archive`;
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return `/jira/servicedesk/projects/${projectKey}/issues/archive`;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return `/jira/core/projects/${projectKey}/issues/archive`;
            case 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT:
                return `/jira/product-discovery/projects/${projectKey}/issues/archive`;
            default:
                return '/jira/issues/archive';
        }
    };
});
parcelRegister("3fAi8", function(module, exports) {
    $parcel$export(module.exports, "useFieldValue", ()=>$ddbc380ab4ee430c$export$b79fae7fbe3ac392);
    $parcel$export(module.exports, "useFieldsValues", ()=>$ddbc380ab4ee430c$export$25b73e671fe7a8fa);
    $parcel$export(module.exports, "useFieldValuesForIssues", ()=>$ddbc380ab4ee430c$export$ac289b84121829df);
    $parcel$export(module.exports, "useMultiFieldValuesForIssues", ()=>$ddbc380ab4ee430c$export$915cdeec521b54f7);
    $parcel$export(module.exports, "FieldValueSubscriber", ()=>$ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
    $parcel$export(module.exports, "useFieldsValuesActions", ()=>$ddbc380ab4ee430c$export$612d9bcb0c9d8976);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UikQ = parcelRequire("1UikQ");
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
            setState({
                [issueKey]: fields
            });
        };
    const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
            const newIssues = {};
            issues.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState(newIssues);
        };
    const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: {
                    ...getState()[issueKey],
                    [fieldKey]: value
                }
            });
        };
    const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
            const issueFieldValues = getState()[issueKey];
            return issueFieldValues && issueFieldValues[fieldKey];
        };
    const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: (0, ($parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
            });
        };
    const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
            if (issues.length === 0) return;
            const newIssues = {};
            issues.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState((0, ($parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
        };
    const $ddbc380ab4ee430c$var$actions = {
        setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
        getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
        setIssue: $ddbc380ab4ee430c$var$setIssue,
        mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
        setIssues: $ddbc380ab4ee430c$var$setIssues,
        mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
    };
    const $ddbc380ab4ee430c$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-fields',
        initialState: {},
        actions: $ddbc380ab4ee430c$var$actions
    });
    const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
        const issueFieldValues = state[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
    const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            }));
    const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
            if (!state[issueKey]) return accumulator;
            const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
                acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                    fieldKey: fieldKey,
                    issueKey: issueKey
                });
                return acc;
            }, {});
            accumulator[issueKey] = fieldValue;
            return accumulator;
        }, {});
    const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
    const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValueSelector
    });
    const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getAllFields
    });
    const $ddbc380ab4ee430c$export$ac289b84121829df = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
    });
    const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
    });
    const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, (0, parcelRequire("51nlc")).createSubscriber)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValueSelector
    });
    const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: null
    });
    const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
        const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
        const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
            const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
            const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
            const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
            const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
            const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
            const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
            return {
                setIssue: setIssueAction,
                setFieldValue: setFieldValueAction,
                getFieldValue: getFieldValueAction,
                mergeIssue: mergeIssueAction,
                setIssues: setIssuesAction,
                mergeIssues: mergeIssuesAction
            };
        }, [
            fieldValueStoreActions
        ]);
        return [
            null,
            fieldsValuesActions
        ];
    };
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("isuse", function(module, exports) {
    $parcel$export(module.exports, "MountEvent", ()=>$1df0619a43ad69d9$export$2c6963927dbc68f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    class $1df0619a43ad69d9$var$MountEventComponent extends (0, $5uXOq.Component) {
        componentDidMount() {
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: 'mounted'
            });
            if (this.props.onMount) this.props.onMount(analyticsEvent);
        }
        render() {
            return null;
        }
    }
    const $1df0619a43ad69d9$export$2c6963927dbc68f1 = (0, (0, parcelRequire("cb25w")).default)()($1df0619a43ad69d9$var$MountEventComponent);
});
parcelRegister("5ING5", function(module, exports) {
    $parcel$export(module.exports, "ARCHIVE_ISSUE_MODAL_WIDTH_CATEGORY", ()=>$f2d76d919b5758cc$export$2ac06baa43be057);
    $parcel$export(module.exports, "ESC_KEY", ()=>$f2d76d919b5758cc$export$45f4d5e73efcfde8);
    $parcel$export(module.exports, "ISSUE_VIEW_URL_REGEX", ()=>$f2d76d919b5758cc$export$cbf34536d6076514);
    $parcel$export(module.exports, "ISSUE_ARCHIVE_API", ()=>$f2d76d919b5758cc$export$1c9d135d7bb1047);
    $parcel$export(module.exports, "TRIGGER_POINT_KEY_ISSUE_VIEW", ()=>$f2d76d919b5758cc$export$501c618f5224bbb);
    $parcel$export(module.exports, "TRIGGER_POINT_KEY_ISSUE_NAVIGATOR", ()=>$f2d76d919b5758cc$export$f64573f447a64548);
    $parcel$export(module.exports, "TRIGGER_POINT_KEY_BOARD_VIEW", ()=>$f2d76d919b5758cc$export$a1eb5fb00be2a7d1);
    const $f2d76d919b5758cc$export$2ac06baa43be057 = 'small';
    const $f2d76d919b5758cc$export$45f4d5e73efcfde8 = 'Escape';
    const $f2d76d919b5758cc$export$cbf34536d6076514 = /.*\/browse\/[^/]+/;
    const $f2d76d919b5758cc$export$1c9d135d7bb1047 = '/rest/api/2/issue/archive';
    const $f2d76d919b5758cc$export$501c618f5224bbb = 'issue-view';
    const $f2d76d919b5758cc$export$f64573f447a64548 = 'issue-navigator';
    const $f2d76d919b5758cc$export$a1eb5fb00be2a7d1 = 'board-view';
});
parcelRegister("cDZaH", function(module, exports) {
    $parcel$export(module.exports, "ArchiveIssueModalStore", ()=>$40459da096a405f9$export$c5cad849002b274b);
    $parcel$export(module.exports, "useArchiveIssueModalActions", ()=>$40459da096a405f9$export$b7e685898567f722);
    var $3sQ5x;
    var $iXqE5;
    var $iP93q;
    var $tr6Ns;
    const $40459da096a405f9$export$c5cad849002b274b = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: (0, parcelRequire("tr6Ns")).initialState,
        actions: (0, (0, parcelRequire("iP93q")).ArchiveIssueModalActions),
        name: 'archiveIssueModalStore'
    });
    const $40459da096a405f9$export$b7e685898567f722 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($40459da096a405f9$export$c5cad849002b274b);
});
parcelRegister("iP93q", function(module, exports) {
    $parcel$export(module.exports, "ArchiveIssueModalActions", ()=>$0edc0fbae339598b$export$69579d834733fb34);
    const $0edc0fbae339598b$export$69579d834733fb34 = {
        openArchiveIssueModal: ({ issueKey: issueKey, issueId: issueId, onIssueArchiveSuccess: onIssueArchiveSuccess, onCloseIssueViewModal: onCloseIssueViewModal, triggerPointKey: triggerPointKey })=>({ setState: setState })=>{
                setState({
                    isArchiveIssueModalOpen: true,
                    issueKey: issueKey,
                    issueId: issueId,
                    onIssueArchiveSuccess: onIssueArchiveSuccess,
                    onCloseIssueViewModal: onCloseIssueViewModal,
                    triggerPointKey: triggerPointKey
                });
            },
        closeArchiveIssueModal: ()=>({ setState: setState })=>{
                setState({
                    isArchiveIssueModalOpen: false,
                    issueKey: null,
                    issueId: null,
                    onIssueArchiveSuccess: null,
                    onCloseIssueViewModal: null,
                    triggerPointKey: null
                });
            }
    };
});
parcelRegister("tr6Ns", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$75b2be9671247dca$export$d4c72bab9d6cc13a);
    const $75b2be9671247dca$export$d4c72bab9d6cc13a = {
        isArchiveIssueModalOpen: false,
        issueKey: null,
        issueId: null,
        onIssueArchiveSuccess: null,
        onCloseIssueViewModal: null,
        triggerPointKey: null
    };
});
parcelRegister("c441l", function(module, exports) {
    $parcel$export(module.exports, "useArchiveIssueModalStates", ()=>$10549a260b21f72f$export$6b0867d94ec2f290);
    var $3sQ5x;
    var $cDZaH;
    const $10549a260b21f72f$export$6b0867d94ec2f290 = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("cDZaH")).ArchiveIssueModalStore));
});
parcelRegister("b9xX7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$15ebf16542ff44b1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $15ebf16542ff44b1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        archiveModalTitle: {
            "id": "issue-archival-modal.archive-modal-title",
            "defaultMessage": "You\u2019re about to archive this issue"
        },
        archiveModalDescription: {
            "id": "issue-archival-modal.archive-modal-description",
            "defaultMessage": "This issue and any subtasks will be archived. You won't be able to edit them, and they will no longer appear in this project. <br></br><br></br>You can restore this issue from  <b>Archived issues</b>."
        },
        archiveModalDescriptionLOne: {
            "id": "issue-archival-modal.archive-modal-description-l-one",
            "defaultMessage": "This issue will be archived. You won't be able to edit it, and it will no longer appear in this project. <br></br><br></br>You can restore this issue from  <b>Archived issues</b>."
        },
        issueArchiveButton: {
            "id": "issue-archival-modal.issue-archive-button",
            "defaultMessage": "Archive"
        },
        closeArchiveModalButton: {
            "id": "issue-archival-modal.close-archive-modal-button",
            "defaultMessage": "Cancel"
        },
        issueArchivalErrorFlagTitle: {
            "id": "issue-archival-modal.issue-archival-error-flag-title",
            "defaultMessage": "We couldn\u2019t archive the issue {issueKey}. Wait a few moments, then try again."
        },
        issueArchivalSuccessFlagTitle: {
            "id": "issue-archival-modal.issue-archival-success-flag-title",
            "defaultMessage": "We've archived the issue {issueKey}."
        },
        issueArchivalSuccessFlagActionViewInArchive: {
            "id": "issue-archival-modal.issue-archival-success-flag-action-view-in-archive",
            "defaultMessage": "View all archived issues"
        },
        issueArchivalSuccessFlagActionViewInArchiveIssueTermRefresh: {
            "id": "issue-archival-modal.issue-archival-success-flag-action-view-in-archive-issue-term-refresh",
            "defaultMessage": "View all archived work items"
        },
        issueArchivalSuccessFlagActionViewIssue: {
            "id": "issue-archival-modal.issue-archival-success-flag-action-view-issue",
            "defaultMessage": "View issue"
        },
        archiveModalTitleIssueTermRefresh: {
            "id": "issue-archival-modal.archive-modal-title-issue-term-refresh",
            "defaultMessage": "You\u2019re about to archive this work item"
        },
        archiveModalDescriptionIssueTermRefresh: {
            "id": "issue-archival-modal.archive-modal-description-issue-term-refresh",
            "defaultMessage": "This work item and any subtasks will be archived. You won't be able to edit them, and they will no longer appear in this project. <br></br><br></br>You can restore this work item from  <b>Archives</b>."
        },
        archiveModalDescriptionLOneIssueTermRefresh: {
            "id": "issue-archival-modal.archive-modal-description-l-one-issue-term-refresh",
            "defaultMessage": "This work item will be archived. You won't be able to edit it, and it will no longer appear in this project. <br></br><br></br>You can restore this work item from  <b>Archives</b>."
        },
        issueArchivalErrorFlagTitleIssueTermRefresh: {
            "id": "issue-archival-modal.issue-archival-error-flag-title-issue-term-refresh",
            "defaultMessage": "Something went wrong at our end. We couldn\u2019t archive the work item ({issueKey}). Refresh and try again."
        },
        issueArchivalSuccessFlagTitleIssueTermRefresh: {
            "id": "issue-archival-modal.issue-archival-success-flag-title-issue-term-refresh",
            "defaultMessage": "The work item ({issueKey}) has been archived."
        },
        issueArchivalSuccessFlagActionViewIssueIssueTermRefresh: {
            "id": "issue-archival-modal.issue-archival-success-flag-action-view-issue-issue-term-refresh",
            "defaultMessage": "View work item"
        }
    });
});
parcelRegister("5l8yo", function(module, exports) {
    $parcel$export(module.exports, "useArchiveIssue", ()=>$b3da0334d88bcb57$export$8726fa65ba085232);
    var $5uXOq = parcelRequire("5uXOq");
    var $eusud;
    var $5ING5;
    const $b3da0334d88bcb57$export$8726fa65ba085232 = ()=>{
        const archiveIssue = (0, $5uXOq.useCallback)(async (issueKey, onSuccess, onError)=>{
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)((0, (0, parcelRequire("5ING5")).ISSUE_ARCHIVE_API), {
                    body: JSON.stringify({
                        issueIdsOrKeys: [
                            issueKey
                        ]
                    })
                });
                onSuccess();
            } catch (error) {
                onError();
            }
        }, []);
        return archiveIssue;
    };
});
parcelRegister("25qsa", function(module, exports) {
    $parcel$export(module.exports, "isIssueViewPage", ()=>$f98ceec72f83f256$export$d121412a48c6ebc0);
    var $5ING5;
    const $f98ceec72f83f256$export$d121412a48c6ebc0 = ()=>window.location.pathname.match((0, (0, parcelRequire("5ING5")).ISSUE_VIEW_URL_REGEX));
});
